import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const W4assistance = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">W-4 Assistance</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Simplify Your W-4 Filing with Expert Guidance
          </h1>
          <p className="tax-section-description">
            Filling out the IRS Form W-4 correctly is more important than most
            taxpayers realize. This form directly determines how much federal
            income tax is withheld from each paycheck. An incorrectly completed
            W-4 could result in too little tax being withheld—leading to an
            unexpected tax bill at year-end—or too much tax being withheld,
            which unnecessarily reduces your take-home pay. At Litax
            , we make sure your W-4 works for you, not against you.
          </p>

          <h2 className="tax-subheading">Why the W-4 Matters</h2>
          <p className="tax-section-description">
            The W-4 is not a one-time form you file and forget. Life changes,
            new income sources, and evolving tax laws all impact your tax
            situation. Keeping your W-4 updated ensures that your withholdings
            accurately match your real obligations. With our guidance, you can
            avoid surprises, balance your cash flow, and plan ahead with
            confidence.
          </p>

          <h2 className="tax-subheading">How We Help with W-4 Completion</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Comprehensive Income Review:</strong> We analyze all your
              income sources—primary job, part-time work, freelance earnings,
              or investment income—to calculate the most accurate withholding.
            </li>
            <li>
              <strong>Filing Status Guidance:</strong> Choosing the right filing
              status (single, married filing jointly, married filing separately,
              or head of household) can significantly affect your withholding.
              We help you select the option that maximizes your benefit.
            </li>
            <li>
              <strong>Dependents & Tax Credits:</strong> Claiming dependents,
              Child Tax Credits, or other applicable benefits requires careful
              calculation. We ensure these are applied correctly to prevent
              under- or over-withholding.
            </li>
            <li>
              <strong>Custom Adjustments:</strong> Whether you expect bonuses,
              extra income, or significant deductions, we customize your W-4 to
              reflect your financial reality.
            </li>
            <li>
              <strong>Annual & Life-Event Reviews:</strong> Marriage, divorce,
              a new child, or a career change can all affect your taxes. We
              provide ongoing assistance to update your W-4 whenever your
              situation changes.
            </li>
          </ul>

          <h2 className="tax-subheading">Common Mistakes We Help You Avoid</h2>
          <ul className="tax-section-description">
            <li>
              Claiming too many allowances and ending up with a tax bill.
            </li>
            <li>
              Forgetting to update after a life event like marriage or
              parenthood.
            </li>
            <li>
              Not accounting for multiple jobs or spousal income.
            </li>
            <li>
              Misunderstanding how deductions and credits reduce withholding.
            </li>
          </ul>

          <h2 className="tax-subheading">Why Choose Litax ?</h2>
          <p className="tax-section-description">
            Our team of Certified Public Accountants (CPAs) and Enrolled Agents
            (EAs) specializes in tax planning and compliance. With our
            personalized W-4 assistance, you’ll gain peace of mind knowing that
            your paycheck withholdings are optimized for your unique financial
            situation. No more guesswork—just clear, professional guidance that
            keeps you on track throughout the year.
          </p>

          <p className="tax-section-description">
            Take control of your paycheck and eliminate the uncertainty of tax
            season. Contact Litax  today for expert W-4 assistance
            and start managing your withholdings the right way.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default W4assistance;
